// As-of / freshness chip used under the hub KPI row (storefront hub chrome).

import React from 'react';

export interface AsOfChipProps {
  label?: string;
  isLive?: boolean;
  title?: string;
}

export function AsOfChip({
  label = 'Live-computed',
  isLive = true,
  title,
}: AsOfChipProps) {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[10px] text-[#717182]"
      title={title}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full ${isLive ? 'bg-emerald-500' : 'bg-slate-400'}`}
        aria-hidden
      />
      {label}
    </span>
  );
}

export default AsOfChip;
